const wrapper = "_35sw24z5lx";
const content = "_35scil37ct";

export { content, wrapper };
import "./_dropzone.style.linaria.module.css";
//# sourceMappingURL=_dropzone.style.js.map
